import { ConnectedRouter } from "connected-react-router";
import React from "react";
import { Route, Switch } from "react-router-dom";
import NotFound from "./errors/NotFound";
import Flight from "./flight";
import history from "./history";
import Home from "./home";
import Missions from "./missions/Missions";
import Profile from "./profile";
import ProfilePassenger from "./profilePassenger";
import Schedule from "./schedule";
import AircraftModel from "./settings/aircraft-model";
import AircraftType from "./settings/aircraft-type";
import Aircrafts from "./settings/aircrafts";
import CostCenter from "./settings/costcenter";
import Manufacturers from "./settings/manufacturers";
import NotificationGroups from "./settings/notificationgroups";
import Passengers from "./settings/passengers";
import Providers from "./settings/providers";
import Providertype from "./settings/providertype";
import SectorFamily from "./settings/sectorfamily";
import Treatments from "./settings/treatments";
import Users from "./settings/users";

const Routes = () => (
  <ConnectedRouter history={history}>
    <Switch>
      <Route exact path="/" component={Home} />
      <Route path="/users" component={Users} />
      <Route path="/passengers" component={Passengers} />
      <Route path="/schedule" component={Schedule} />
      <Route path="/cost-center" component={CostCenter} />
      <Route path="/sector-family" component={SectorFamily} />
      <Route path="/treatments" component={Treatments} />
      <Route path="/notification-groups" component={NotificationGroups} />
      <Route path="/aircrafts-models" component={AircraftModel} />
      <Route path="/aircrafts-types" component={AircraftType} />
      <Route path="/providers" component={Providers} />
      <Route path="/provider-type" component={Providertype} />
      <Route path="/manufacturers" component={Manufacturers} />
      <Route path="/aircrafts" component={Aircrafts} />
      <Route path="/flight/:id" component={Flight} />
      <Route path="/new-mission/:id" component={Missions} />
      <Route path="/profile" component={Profile} />
      <Route path="/profile_passenger" component={ProfilePassenger} />
      <Route component={NotFound} />
    </Switch>
  </ConnectedRouter>
);

export default Routes;



// WEBPACK FOOTER //
// ./src/routes/Routes.js